<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'
import { ModalDefault } from '@shared/ui/modals'
import { InputPrimary } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalCreateAssessmentTemplate } from '../../../model/assessments/modal-create-assessment-template.hook'

defineOptions({
  name: 'ModalCreateAssessmentTemplate',
})

const {
  refIsOpen,
  refIsLoading,
  refTitle,
  refType,
  refDisciplineCode,
  refGrade,
  refIsValid,
  typeOptions,
  disciplineOptions,
  gradeSelectOptions,
  setTitle,
  closeModal,
  createTemplate,
} = useModalCreateAssessmentTemplate()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsLoading"
    title="Create assessment template"
    is-close-button
    @click:overlay="closeModal"
    @click:close="closeModal"
  >
    <div class="modal-create-assessment-template">
      <InputPrimary
        id="assessment-template-title"
        label="Title"
        required
        placeholder="e.g. Baseline diagnostic — Grade 4"
        :value="refTitle"
        @update:value="setTitle"
      />

      <AppSelect
        v-model="refType"
        :options="typeOptions"
        label="Type"
        placeholder="Select type"
        required
      />

      <AppSelect
        v-model="refDisciplineCode"
        :options="disciplineOptions"
        label="Discipline"
        placeholder="Select discipline"
        required
      />

      <AppSelect
        v-model="refGrade"
        :options="gradeSelectOptions"
        label="Grade"
        placeholder="Select grade"
        required
      />
    </div>

    <template #controls>
      <BtnPrimary
        text="Create"
        color="emerald"
        :disabled="!refIsValid || refIsLoading"
        @click="createTemplate"
      />
      <BtnSecondary
        text="Cancel"
        @click="closeModal"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalCreateAssessmentTemplate.scss" />
